module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/QCthm/tc-custom/9781452112855.jpg?1737758516881",
      "alt": "This image is the cover for the book Sunday Brunch"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sunday Brunch\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A year’s worth of recipes for Sunday socializing, from muffins to mimosas.")]), _c('br'), _c('br'), _vm._v("Betty Rosbottom, beloved author of "), _c('i', [_vm._v("Sunday Soup")]), _vm._v(" and "), _c('i', [_vm._v("Sunday Roasts")]), _vm._v(", knows how to make Sundays feel special. For this title in her Sunday series, she turns to the most leisurely and convivial meal of the week, brunch. "), _c('br'), _c('br'), _vm._v("Providing a year’s worth of special meals, this book contains eighty mouthwatering recipes for eggs, stratas, pancakes, waffles, quickbreads, hash, and beverages, as well as thirty-two tantalizing color photographs and dozens of delicious menus. Full of enduring staples and delicious surprises, "), _c('i', [_vm._v("Sunday Brunch")]), _vm._v(" will become the go-to for tried and true Sunday treats."), _c('br'), _c('br'), _vm._v("Try: Plum Parfaits with Yogurt and Granola * Espresso-Scented Coffee Cake * Golden Pecan Waffles with Warm Salted Caramel Sauce and Bananas * Eggs Benedict with New Orleans Accents * Spicy Shrimp and Grits * and many more\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Betty Rosbottom, Susie Cushner\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Betty Rosbottom has been a cooking teacher, columnist, and cookbook author for two decades. She lives part-time in Amherst, Massachusetts, and Paris, France.Susie Cushner is a food and lifestyle photographer based in New York.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chronicle Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0